import { FC, useMemo, useState } from 'react';

import { StaggerFadeIn, StaggerItem } from '../../../components/motion/index';
import { PaginationController } from '../../../components/pagination-controller/index';
import { useScreenSize } from '../../../hooks/index';
import { getLibraryCoverByCategory } from '../constants/library-category-cover.constant';
import { libraryData } from '../data/library-data';
import { LibraryModalType } from '../enum/library-modal-type.enum';
import { LIBRARY_MOBILE_BREAKPOINT_PX } from '../library';
import { LibraryModalStore } from '../store/library-modal.store';
import { LibraryResourceCard } from './library-resource-card';

export const LibraryResourceList: FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { width } = useScreenSize();
  const isMobile = width < LIBRARY_MOBILE_BREAKPOINT_PX;
  const openModal = LibraryModalStore(({ openModal }) => openModal);
  const itemsPerPage = isMobile ? 5 : libraryData.length;
  const totalPages = Math.max(1, Math.ceil(libraryData.length / itemsPerPage));

  const paginatedItems = useMemo(() => {
    const offset = (currentPage - 1) * itemsPerPage;
    return libraryData.slice(offset, offset + itemsPerPage);
  }, [currentPage, itemsPerPage]);

  return (
    <>
      <StaggerFadeIn
        className="grid w-full grid-cols-1 gap-4 min-[720px]:grid-cols-2 min-[1025px]:grid-cols-3"
        key={currentPage}
      >
        {paginatedItems.map((item) => (
          <StaggerItem key={item.id}>
            <LibraryResourceCard
              availableIn={item.availableIn}
              category={item.category}
              coverImage={getLibraryCoverByCategory(item.category)}
              description={item.description}
              onDownload={() => openModal({ payload: item, type: LibraryModalType.DOWNLOAD })}
              title={item.title}
            />
          </StaggerItem>
        ))}
      </StaggerFadeIn>
      {isMobile && (
        <PaginationController
          currentPage={currentPage}
          itemsCount={libraryData.length}
          itemsToFetch={itemsPerPage}
          itemsToFetchMap={[5]}
          onClick={setCurrentPage}
          onFetchAmountChange={() => {}}
          totalPages={totalPages}
          wrapperClassName="mt-2 px-0"
        />
      )}
    </>
  );
};
